import { Input, Modal } from 'antd';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useState } from 'react';

import ButtonDefault, { ButtonVariants } from '../../shared/basic/button';
import { handleEmailOnBlur } from '../../V2/SignUpModal';
import { ZebraLearnLogo } from '../../../../assets';
import EmailIcon from '../../../../assets/Icons/Mail';
import appwriteService from '../../../config/appwrite';
import { tempUserIFrame } from '../../../services/IFrame/apis';

interface ModalComponentProps {
  visible: boolean;
  onCancel: () => void;
  isClosable?: boolean;
  isIFrame?: boolean;
}

const IFrameModal: React.FC<ModalComponentProps> = ({ visible, onCancel }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const router = useRouter();
  const { book_id, code: afc } = router.query;
  const handleOk = () => {
    setConfirmLoading(true);

    setTimeout(() => {
      setConfirmLoading(false);
      onCancel();
    }, 2000);
  };

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [errors, setErrors] = useState({
    email: '',
    password: '',
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validationErrors = {
      email: '',
      password: '',
    };
    if (!formData.email) {
      validationErrors.email = 'Email is required';
    } else if (!isValidEmail(formData.email)) {
      validationErrors.email = 'Please enter valid email';
    }
    if (formData.email) {
      const res = await handleEmailOnBlur(formData.email);
      validationErrors.email = res;
    }

    setErrors(validationErrors);

    if (Object.values(validationErrors).every((error) => !error)) {
      await handleEmailLoginTempIFrame(formData.email);
    }
  };

  const isValidEmail = (email: string) => {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    return emailRegex.test(email);
  };

  const handleEmailLoginTempIFrame = async (emailValue: string) => {
    try {
      await appwriteService.logoutIfSessionExists();
      const session = await appwriteService.createAnonymousSession();
      if (session && typeof window !== undefined) {
        await tempUserIFrame({
          code: afc as string,
          email: emailValue as string,
          product_id: book_id as string,
          source: window.location.href,
          user_id: session?.userId,
        });
        if (session?.userId && typeof localStorage !== 'undefined') {
          localStorage.setItem('user_id_iframe', session?.userId);
        }
        onCancel();
      }
    } catch (error: any) {
      if (process.env.NEXT_PUBLIC_APP_ENV === 'development') {
        console.error('Error initializing messaging:', error);
      }
    }
  };

  return (
    <Modal
      title=''
      open={visible}
      centered={true}
      onOk={handleOk}
      maskClosable={false}
      closable={false}
      confirmLoading={confirmLoading}
      onCancel={onCancel}
      footer={false}
      className='customLoginModal bg-bgColor bg-opacity-70  pt-5  relative rounded-2xl border-2 border-borderDarkGray backdrop-filter backdrop-blur-md '
    >
      <div className='flex items-center gap-y-10 flex-col justify-center px-5 md:px-10'>
        <div className={` z-30  flex flex-col gap-y-1 w-full `}>
          <div className='relative pt-2 md:pt-4'>
            <span className=' flex justify-center w-full'>
              <Image
                src={ZebraLearnLogo}
                alt='Logo'
                className='object-contain h-3.5 w-full'
              />
            </span>
          </div>
          <div className='border-b-2 border-backgroundGray py-3' />
          <div className='py-3 flex flex-col gap-y-2 '>
            <h1 className='text-xl flex justify-center gap-x-2 font-medium lg:font-normal lg:text-2xl mt-1 leading-10 text-fadedWhite text-center w-full'>
              Enter Email to Continue
            </h1>
          </div>

          <form onSubmit={handleSubmit} className='flex flex-col mt-2 gap-y-3 '>
            <div className='col-span-1 flex-col flex gap-y-.5'>
              <Input
                name='email'
                type='email'
                autoComplete='current-email'
                style={{
                  backgroundColor: '#000000',
                }}
                value={formData.email}
                placeholder='Email'
                prefix={
                  <span className='pr-2'>
                    <EmailIcon filled={true} />
                  </span>
                }
                onChange={handleChange}
                size='large'
                className='border text-sm focus-within:bg-bgColor  placeholder:text-textDarkGrayColor rounded-xl border-bgDarkGray  py-3  text-white bg-bgColor customInputBlack makeBgBlack'
              />
              {errors.email && <p className='text-red-500'>{errors.email}</p>}
            </div>

            <span className='flex justify-center mt-2 pb-5'>
              <ButtonDefault
                size={4}
                variant={ButtonVariants.WHITE}
                className='p-1 w-full'
                rounded={true}
                onClick={handleSubmit}
              >
                <span className='flex text-sm font-bold gap-x-2 px-4 py-1 whitespace-nowrap'>
                  Continue
                </span>
              </ButtonDefault>
            </span>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default IFrameModal;
